import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';
import { videoCategories } from '@/mocks/videos';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="container-main py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="text-xl font-bold text-white hover:text-primary-400 transition-colors">
              {siteInfo.logo}
            </Link>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed max-w-sm">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a
                href={siteInfo.social.weibo}
                rel="nofollow noopener noreferrer"
                target="_blank"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors"
                aria-label="微博"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-tiktok-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">视频分类</h4>
            <ul className="space-y-2">
              {videoCategories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">快捷链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  创作者中心
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  帮助中心
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  隐私政策
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line text-foreground-500"></i>
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-phone-line text-foreground-500"></i>
                {siteInfo.phone}
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-map-pin-line text-foreground-500 mt-0.5"></i>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-700/50">
        <div className="container-main py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} {siteInfo.fullName} 版权所有 | 京ICP备2024XXXXXXXX号
          </p>
          <p className="text-xs text-foreground-500">
            本站所有视频内容均来自合作方授权，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}